/**
 * @packageDocumentation
 * Creates and animates the end-of-round summary screen that presents total earnings and reset controls.
 */
/**
 * Represents the end page container for displaying win/lose results
 * @extends PIXI.Container
 */
import * as PIXI from "pixi.js"; 
import { Assets } from 'pixi.js'; 
import { GridProperties,EndPageProperties } from "../config"; 
import {betArea} from "./betArea"
import { currencySymbol } from "./server";
import { applyCent, brightnessFilter,shockwave, font_main  } from "./global";
import { gsap } from "gsap/gsap-core";
import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { SoundManager } from "./sounds";

export class createEndPage extends PIXI.Container{
    /** Background shape for the end page */
    private endShape:PIXI.Graphics;

    /** Container for collect button */
    public collectButContainer!:PIXI.Container;

    /** Container for win text elements */
    public WinTextContainer!:PIXI.Container;

    /** Static text element for displaying win amount */
    static WinText:PIXI.Text;

    /** Secondary static text element for win amount */
    static WinText1:PIXI.Text;

    /** Text element for congratulations message */
    public ContgratulationsTxt!:PIXI.Text;

    /** Text element for "YOU WON" message */
    public YouWonTxt!:PIXI.Text;

    /** Timer for celebration animation */
    private celebrationTime!:NodeJS.Timeout;

    /** Total time for win text update animation */
    static winUpdateTime = EndPageProperties.textUpdateTotalTime;

    /** Function to hide the end page */
    public hideEndpage!:()=>void;

    /**
     * Creates an instance of createEndPage
     * Initializes the end page container with background and text elements
     */
    constructor(){ 
        super(); 
        this.endShape = new PIXI.Graphics();
        this.endShape
            .rect(0, 0, GridProperties.TotalColumns*((GridProperties.boxWidth+GridProperties.gapBtwnBoxes)), GridProperties.TotalRows*((GridProperties.boxHeight+GridProperties.gapBtwnBoxes)))
            .fill({ color: "red", alpha: 0.9}); 
        this.endShape.x = -(GridProperties.boxWidth+GridProperties.gapBtwnBoxes)/2
        this.endShape.y = -(GridProperties.boxHeight+GridProperties.gapBtwnBoxes)/2
        this.endShape.alpha = 0

        this.addChild(this.endShape)
        this.WinTextContainer = new PIXI.Container();
        this.addChild(this.WinTextContainer);  
        this.collectBtn()
        this.Wintext() 
        this.WinTextContainer.pivot.set(this.WinTextContainer.width/2,this.WinTextContainer.height/2) 
        this.WinTextContainer.x = this.endShape.x+this.WinTextContainer.width/2  + this.endShape.width/2 ;
        this.WinTextContainer.y = this.endShape.y+this.WinTextContainer.height/2 + this.endShape.height/2-50; 
    };

    /**
     * Creates and configures the collect button
     */
    public collectBtn(){
        this.collectButContainer = new PIXI.Container();
        let collectButBg:PIXI.Sprite = new PIXI.Sprite(Assets.get("collect_btn"));
        collectButBg.anchor.set(0.5);
        // collectButBg.scale.x = 2
        // collectButBg.scale.y = 0.75 
        
        let collectText:PIXI.Text = new PIXI.Text({text:"COLLECT",style:{
            fontFamily: font_main, 
            align:"center",
            fill: 'white', 
            fontSize: 40,
            fontWeight: 'lighter',
            stroke:{
                color:"black",
                width:4,
                join:"round"

            },
        }});
        collectText.anchor.set(0.5);
        collectText.y = -3

        this.collectButContainer.addChild(collectButBg,collectText);
        this.addChild(this.collectButContainer);
        this.collectButContainer.interactive = true;
        this.collectButContainer.cursor = "pointer";
        this.collectButContainer.pivot.set(this.collectButContainer.width/2,this.collectButContainer.height/2) 
        this.collectButContainer.x = this.endShape.x+this.collectButContainer.width/2  + this.endShape.width/2 ;
        this.collectButContainer.y = this.endShape.y+this.collectButContainer.height/2 + this.endShape.height-60; 
        this.collectButContainer.on("pointertap",()=>{
            SoundManager.coinCollectSndPlay(); 
            SoundManager.end_popup_ambienceStop();  
            SoundManager.end_popup_winStop()

            clearInterval(this.celebrationTime) 
            this.hideEndpage()
        });
        this.collectButContainer.visible = false;
        this.collectButContainer.on("pointerover",()=>{
            this.collectButContainer.filters = [brightnessFilter] 
        })
        this.collectButContainer.on("pointerout",()=>{
            this.collectButContainer.filters = [] 
        })
    } 

    /**
     * Creates and configures win text elements
     */
   Wintext(){  
        this.ContgratulationsTxt = new PIXI.Text({text:"CONGRATULATIONS!",style:{
            fontFamily: font_main, 
            stroke:{
                color:"white",
                width:4,
                join:"round"

            },
            align:"center",
            fill: '#00aaff', 
            fontSize: 80,
            fontWeight: 'bold',
            letterSpacing:4
            
        }});
        this.ContgratulationsTxt.anchor.set(0.5);  
        this.ContgratulationsTxt.y = -60;
        this.WinTextContainer.addChild(this.ContgratulationsTxt)


        this.YouWonTxt = new PIXI.Text({text:"YOU WON",style:{
            fontFamily: font_main,
            stroke:{
                color:"#fff",//"#aaff01",
                width:4,
                join:"round"

            },
            
            align:"center",
            fill:"#66c509",// '#fccf3d', 
            fontSize: 60,
            fontWeight: 'bold',
            letterSpacing:4

        }});
        this.YouWonTxt.anchor.set(0.5);  
        this.WinTextContainer.addChild(this.YouWonTxt)

        this.YouWonTxt.y = this.ContgratulationsTxt.y+this.ContgratulationsTxt.height



        createEndPage.WinText1 = new PIXI.Text({text:currencySymbol+2+".00",style:{
            fontFamily: font_main,
            stroke:{
                color:"white",
                width:8,
                join:"round"

            }, 
            align:"center",
            fill: 'white', 
            fontSize: 45,
            fontWeight: 'bold',
            letterSpacing:4

        }});
        createEndPage.WinText1.anchor.set(0.5);  
        createEndPage.WinText1.y = this.YouWonTxt.y+this.YouWonTxt.height+10
        this.WinTextContainer.addChild(createEndPage.WinText1)

        createEndPage.WinText = new PIXI.Text({text:currencySymbol+2+".00",style:{
            fontFamily: font_main,
            stroke:{
                color:"black",
                width:4,
                join:"round"

            },
            align:"center",
            fill: 'yellow', 
            fontSize: 45,
            fontWeight: 'bold',
            letterSpacing:4

        }});
        createEndPage.WinText.anchor.set(0.5);  
        createEndPage.WinText.y = this.YouWonTxt.y+this.YouWonTxt.height+10
        this.WinTextContainer.addChild(createEndPage.WinText)



 
    } 

    /**
     * Animates the congratulations and win text
     */
     animateTexts(){ 
        this.ContgratulationsTxt.scale.set(1)
        this.YouWonTxt.scale.set(1) 
        gsap.to(this.ContgratulationsTxt,{duration:1,pixi:{scale:0.9},repeat:-1,yoyo:true,ease:"none"})
        gsap.to(this.YouWonTxt,{duration:1,pixi:{scale:0.9},repeat:-1,yoyo:true,ease:"none"})

        // gsap.to(this.YouWonTxt,{duration:1,pixi:{brightness:0.75},repeat:-1,yoyo:true,ease:"none"})
        // this.ContgratulationsTxt.filters = [shockwave as unknown as PIXI.Filter];
        // this.app.ticker.add(() => shockwave.time += 0.01);
        // shockwave.center = [this.ContgratulationsTxt.x, this.ContgratulationsTxt.y];
    }

    /**
     * Updates the end page text based on win amount
     * @param value - Win amount to display
     */
  public UpdateEndWinText(value:number){
    createEndPage.WinText.text = currencySymbol+(value.toFixed(2)); 
    if(value>0){  
        SoundManager.end_popup_winPlay();
         
        this.collectButContainer.visible = false; 
        (this.collectButContainer.children[1] as PIXI.Text).text = "COLLECT";

        let currentSpecialWin = "YOU WON";  
        if((value)){
          currentSpecialWin = "BIG WIN";
        }
        if((value)){
            currentSpecialWin = "MEGA WIN"; 
        }
        if((value)){
            currentSpecialWin = "SUPER WIN"; 
        }   

        this.YouWonTxt.text  = currentSpecialWin;
        this.ContgratulationsTxt.visible = true
        this.animateTexts()
        this.ContgratulationsTxt.y = -60;
        this.YouWonTxt.y = this.ContgratulationsTxt.y+this.ContgratulationsTxt.height
        createEndPage.WinText1.y = this.YouWonTxt.y+this.YouWonTxt.height+10
        createEndPage.WinText.y = this.YouWonTxt.y+this.YouWonTxt.height+10
        this.collectButContainer.y = this.endShape.y+this.collectButContainer.height/2 + this.endShape.height-40; 

        let tempWinVal = 0;
        let IntervalTime = EndPageProperties.updateIntervalTime;
        let totalInterval_iteration = createEndPage.winUpdateTime/IntervalTime
        let WinvalAdder = value/totalInterval_iteration
        let IntervalID =  setInterval(() => {
            tempWinVal += WinvalAdder;
            if(SoundManager.win_increment.playing()){
                SoundManager.win_incrementStop()
            }
            SoundManager.win_incrementPlay()
            if(tempWinVal>=value){
                SoundManager.win_incrementStop() 
                SoundManager.Coinflip_winSndPlay(); 
                tempWinVal = value;
                clearInterval(IntervalID);
                this.collectButContainer.visible = true;
                gsap.to(createEndPage.WinText,{duration:0.2,pixi:{scale:1.5},repeat:1,yoyo:true,ease:"none"});
                gsap.to(createEndPage.WinText1,{duration:0.2,pixi:{scale:1.5},repeat:1,yoyo:true,ease:"none"});
 
            }
            createEndPage.WinText.text = currencySymbol+(tempWinVal.toFixed(2)); 
            setTimeout(() => {
                applyCent(createEndPage.WinText,tempWinVal);
            }, 10);

            createEndPage.WinText1.text = currencySymbol+(tempWinVal.toFixed(2)); 
            setTimeout(() => {            
             applyCent(createEndPage.WinText1,tempWinVal);
            }, 10);            
        }, IntervalTime);
 
    }else{ 
        SoundManager.end_popup_losePlay();
        this.ContgratulationsTxt.y = -120;
        this.YouWonTxt.y = this.ContgratulationsTxt.y+this.ContgratulationsTxt.height
        createEndPage.WinText1.y = this.YouWonTxt.y+this.YouWonTxt.height+10
        createEndPage.WinText.y = this.YouWonTxt.y+this.YouWonTxt.height+10
        this.collectButContainer.y = this.endShape.y+this.collectButContainer.height/2 + this.endShape.height-120; 
        (this.collectButContainer.children[1] as PIXI.Text).text = "OK"; 
        this.ContgratulationsTxt.visible = false;
        this.YouWonTxt.text  = "YOU DID NOT WIN"
        createEndPage.WinText.text = "TRY AGAIN";
        createEndPage.WinText1.text = "TRY AGAIN"; 

        this.collectButContainer.visible = true; 

    }
    }  

    /**
     * Creates pre-animation for end page transition
     * @param endPage - End page instance to animate
     * @param bgAnim - Background animation callback
     * @returns Spine animation for transition
     */
    formEndPagePreAnim(endPage:createEndPage){ 
        const endPageTransitionAnim = Spine.from({ skeleton: "celebration_anim_json", atlas: "celebration_anim_atlas",scale:1 }); 
        endPageTransitionAnim.state.setAnimation(0,"animation",true); 
        endPageTransitionAnim.scale.set(1);
        endPageTransitionAnim.state.timeScale = 0
        endPageTransitionAnim.visible = false;
        endPageTransitionAnim.state.addListener({
            complete:()=>{
                // this.UpdateEndWinText(totalWin)
               SoundManager.end_popup_ambiencePlay()
            endPageTransitionAnim.state.timeScale = 0;
            endPageTransitionAnim.visible = false
            setTimeout(() => {
            endPage.visible = true 
            }, 10);
            this.celebrationTime =  setInterval(() => {
                }, 2000);
            }
        })
        return endPageTransitionAnim;
    } 
}
